import { render, staticRenderFns } from "./Volunteerdetail.vue?vue&type=template&id=651c1ac4&scoped=true"
import script from "./Volunteerdetail.vue?vue&type=script&lang=js"
export * from "./Volunteerdetail.vue?vue&type=script&lang=js"
import style0 from "./Volunteerdetail.vue?vue&type=style&index=0&id=651c1ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651c1ac4",
  null
  
)

export default component.exports